import React from 'react';

const Error = () => {
  return <div>This is error page</div>;
};

export default Error;
